var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",attrs:{"id":"myModal"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('customEvent')}}},[_c('div',{staticClass:"modal-con img-cover",style:(_vm.myStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }